import styled from "styled-components";

import { CalendarScheduleLines, ClockTime } from "@ui/Assets/MyIcons";
import { rem } from "@ui/helpers";

import { Button } from "../Button";

export const ContractItem = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.grey200};
  border-radius: ${({ theme }) => theme.border.radius.half};
  padding: ${({ theme }) => theme.margins.base_x1_5};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.margins.quarter};
  width: 100%;
  font-size: ${({ theme }) => theme.fonts.sizes.body2};
  font-weight: ${({ theme }) => theme.fonts.weights.normal};
  line-height: ${({ theme }) => theme.fonts.lineHeights.subtitle};
`;

export const ContractInfo = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.margins.base};
`;

export const ContractTime = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.margins.half};
  padding: ${({ theme }) => theme.margins.quarter} 0;
  align-self: center;
`;
export const ScheduleIcon = styled(CalendarScheduleLines).attrs(props => ({
  height: 20,
  width: 20,
  color: props.theme.palette.grey600,
}))`
  align-self: center;
`;

export const ContractDuration = styled.div`
  display: flex;
  flex-direction: column;
`;
export const ClockIcon = styled(ClockTime).attrs(props => ({
  height: 20,
  width: 20,
  color: props.theme.palette.grey600,
}))``;

export const ConfirmButton = styled(Button).attrs({
  variant: "blue",
})`
  align-self: flex-end;
`;
